import { Environment } from '~/types/Environment'

export const environment = process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'local' as Environment
